import React, {Component} from 'react'
import InvestIcon from '@material-ui/icons/Payment'
import Typography from '@material-ui/core/Typography'
import SectionLoader from 'components/SectionLoader'
import Button from '@material-ui/core/Button'
import { FlexDataItem } from 'components/FlexDataView'
import {CryptoInvest} from './CryptoInvest'
import {BankAccountInvest} from './BankAccountInvest'
import {FormattedMessage} from 'react-intl'

export default class Invest extends Component {
  render = () => {
    const {allocation, disabled, onInvest, pendingInvest} = this.props
    return (
      <FlexDataItem>
        <Typography variant='subtitle1'>
          <InvestIcon/><FormattedMessage id="allocation.section.invest" />
        </Typography>
        {/*if*/ allocation.tncsAgreedAt && !disabled ?
          allocation.paymentDestination.type === 'wallets' ?
            <CryptoInvest allocation={allocation}/> :
          allocation.paymentDestination.type === 'bankAccounts' ?
            <BankAccountInvest allocation={allocation}/>
          :
            <div><FormattedMessage id="allocation.section.invest.unsupported" /></div>
        /*else*/ :
          <div style={{margin: '20px 10px'}}>
            <Button style={{width: '100%'}} variant="contained" color='primary' onClick={() => onInvest()}
                    disabled={disabled}><FormattedMessage id="allocation.section.invest.action" /></Button>
          </div>
        }
        {pendingInvest &&
        <SectionLoader/>
        }

      </FlexDataItem>
    )
  }
}
